/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspost_Place_Home_Story1Inputs */

const vi_cmspost_place_home_story1 = /** @type {(inputs: Cmspost_Place_Home_Story1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trang chủ › Câu chuyện`)
};

/**

* @param {Cmspost_Place_Home_Story1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_place_home_story1 = /** @type {((inputs?: Cmspost_Place_Home_Story1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Place_Home_Story1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_place_home_story1(inputs)
});
export { cmspost_place_home_story1 as "cmsPost_place_home_story" }